<template>
  <v-container class=" pa-1 pa-sm-4" fluid>
    <!-- Options -->
    <v-row>
      <v-col sm="12" md="9" class="pb-0 pt-0">
        <v-row class="my-component-list-combobox">
          <v-col>
            <v-combobox
              v-if="isShowComponent"
              label="類別"
              v-model="optionSelected1"
              :items="addonelistlist1"
              @change="handleOnChangeOption1"
            ></v-combobox>
            <v-combobox
              v-else
              label="類別"
              v-model="optionSelected1"
            ></v-combobox>
          </v-col>
          <v-col>
            <v-combobox
              v-if="isShowComponent"
              label="品牌"
              v-model="optionSelected2"
              :items="options2"
              @change="handleOnChangeOption2"
            ></v-combobox>
            <v-combobox
              v-else
              label="品牌"
              v-model="optionSelected2"
            ></v-combobox>
          </v-col>
          <v-col>
            <v-combobox
              v-if="isShowComponent"
              label="系列"
              v-model="optionSelected3"
              :items="options3"
            ></v-combobox>
            <v-combobox
              v-else
              label="系列"
              v-model="optionSelected3"
            ></v-combobox>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <!-- Save & Reset Buttons -->
    <v-row>
      <v-col sm="12" md="9" class="pb-0 pt-0 text-end">
        <v-btn
          class="ma-2"
          elevation="4"
          color="success"
          @click="handleOnNewAddOne"
        >
          <v-icon>mdi-plus-thick</v-icon>
        </v-btn>
        <v-btn
          class="ma-2"
          elevation="4"
          color="error"
          @click="handleOnDeleteAddOne"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <!-- Table -->
    <v-row>
      <v-col sm="12" md="9" class="pb-0 pt-0">
        <v-data-table
          :headers="headers"
          :items="listByOption3"
          item-key="id"
          class="elevation-4 my-component-list-table"
          :search="tableSearch"
          :loading="isSending"
          loading-text="資料更新中..."
          no-data-text="暫無資料"
          no-results-text="沒有匹配的資料"
          show-select
          v-model="tableCBSelected"
          :mobile-breakpoint="tableModes[tableMode].breakpoint"
        >
          <template v-slot:top>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="tableSearch"
                  label="快速搜尋"
                  class="mx-4"
                ></v-text-field>
              </v-col>
            </v-row>
          </template>
          <template v-slot:item.ap="{ item }"> {{ item.ap }}% </template>
          <template v-slot:item.actions="{ item }">
            <v-icon class="mr-2" @click="handleOnEditAddOne(item)">
              mdi-pencil
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <!-- Dialog -->
    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h3>{{ dialogMode ? '新增零組件' : '編輯零組件' }}</h3>
        </v-card-title>
        <!--  -->
        <v-card-text>
          <v-form
            v-if="dialogMode"
            v-model="dialogInputValid"
            @submit.prevent=""
          >
            <v-text-field
              v-model="addoneModel"
              label="型號(項目)"
              :rules="addoneRules1"
              :counter="30"
              required
            ></v-text-field>
            <v-text-field
              v-model="addonePrice"
              label="價格"
              :rules="addoneRules2"
            ></v-text-field>
            <v-switch
              v-model="addoneEnb"
              inset
              color="primary"
              :label="`狀態:${addoneEnb ? '啟用' : '關閉'}`"
            ></v-switch>
          </v-form>
          <v-form v-else v-model="dialogInputValid" @submit.prevent="">
            <v-row>
              <v-col>
                <v-text-field
                  v-model="addoneModel"
                  label="型號(項目)"
                  :rules="addoneRules1"
                  :counter="30"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="">
                <v-text-field
                  v-model="addonePrice"
                  label="舊價格"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="">
                <v-text-field
                  v-model="addoneNewPrice"
                  label="新價格"
                  :rules="addoneRules3"
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="">
                <v-text-field
                  v-model="addoneRF"
                  label="漲跌"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="">
                <v-text-field
                  v-model="addoneAP"
                  label="漲跌幅"
                  disabled
                ></v-text-field>
              </v-col> -->
            </v-row>
            <v-switch
              v-model="addoneEnb"
              inset
              color="primary"
              :label="`狀態:${addoneEnb ? '啟用' : '關閉'}`"
            ></v-switch>
          </v-form>
        </v-card-text>
        <!--  -->
        <v-card-actions>
          <v-row>
            <v-col>
              <v-btn elevation="4" color="error" @click="dialog = false">
                <v-icon>mdi-close-thick</v-icon>
              </v-btn>
            </v-col>
            <v-col class="text-end">
              <v-btn
                elevation="4"
                color="success"
                @click="handleOnDialogSave"
                :disabled="isSending"
              >
                <v-icon>mdi-check-bold</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  data: () => ({
    isShowComponent: true,
    optionSelected1: [],
    optionSelected2: [],
    optionSelected3: [],
    dialog: false,
    dialogInputValid: false,
    dialogMode: true,
    dialogOnSaveFn: undefined,
    addoneModel: '',
    addonePrice: '',
    addoneNewPrice: '',
    addoneRF: '',
    addoneAP: '',
    addoneEnb: true,
    addoneRules1: [
      v => !!v || '不可空白',
      v => v.length <= 30 || '字數不可超過30個字'
    ],
    addoneRules2: [
      v => !!v || '不可空白',
      v => Number.isInteger(Number(v)) || '必須是整數'
    ],
    addoneRules3: [
      v => !!v || '不可空白',
      v => Number.isInteger(Number(v)) || '必須是整數',
      v => Number(v) > 0 || '必須是正整數'
    ],
    // TABLE
    tableSearch: '',
    tableCBSelected: [],
    headers: [
      {
        text: '型號',
        align: 'start',
        value: 'model'
      },
      {
        text: '價格',
        align: 'end',
        value: 'price'
      },
      {
        text: '漲跌',
        align: 'end',
        value: 'rf'
      },
      {
        text: '漲跌幅',
        align: 'end',
        value: 'ap'
      },
      {
        sortable: false,
        value: 'actions'
      }
    ]
  }),
  computed: {
    ...mapState('account', ['uid']),
    ...mapState('admin', [
      'tableModes',
      'tableMode',
      'isSending',
      'addonelistlist1',
      'addonelistlist2',
      'addonelistlist3',
      'addonedetails'
    ]),
    options2() {
      const o = []
      if (!this.optionSelected1) return o
      if (!this.optionSelected1.value) return o
      const id = this.optionSelected1.value
      this.addonelistlist2.forEach(e => {
        if (e.l_id === id) o.push(e)
      })
      return o
    },
    options3() {
      const o = []
      if (!this.optionSelected2) return o
      if (!this.optionSelected2.value) return o
      const id = this.optionSelected2.value
      this.addonelistlist3.forEach(e => {
        if (e.b_id === id) o.push(e)
      })
      return o
    },
    listByOption3() {
      const o = []
      if (!this.optionSelected3) return o
      if (!this.optionSelected3.value) return o
      const s_id = this.optionSelected3.value
      this.addonedetails.forEach(e => {
        if (e.s_id === s_id) o.push(e)
      })
      return o
    },
    visiblePages() {
      return this.listByOption3.slice(
        (this.page - 1) * this.perPage,
        this.page * this.perPage
      )
    }
  },
  methods: {
    ...mapActions('admin', [
      'getAddOneAllOptionList',
      'saveAddOneDetail',
      'getAddOneDetails',
      'updateAddOneDetail',
      'deleteAddOneDetail'
    ]),
    handleOnChangeOption1() {
      ;(async () => {
        this.optionSelected2 = this.options2[0]
        this.optionSelected3 = this.options3[0]
        const { uid } = this
        await this.getAddOneDetails({ uid, l_id: this.optionSelected1.value })
        this.optionSelected3 = ''
        this.$nextTick(async () => {
          this.optionSelected3 = this.options3[0]
          this.isShowComponent = true
        })
      })()
    },
    handleOnChangeOption2() {
      this.optionSelected3 = this.options3[0]
    },
    handleOnNewAddOne() {
      if (this.optionSelected3.length < 1) return
      if (!this.optionSelected3.text) return
      if (!this.optionSelected3.value) return
      const tempOS = this.optionSelected3
      this.dialogMode = true

      this.addoneModel = ''
      this.addonePrice = ''
      this.addoneEnb = 1

      this.dialog = true

      this.dialogOnSaveFn = async () => {
        if (!this.dialogInputValid) return
        this.isShowComponent = false
        this.optionSelected3 = []
        const { addoneModel, addonePrice, uid } = this
        await this.saveAddOneDetail({
          addoneModel,
          addonePrice,
          uid,
          enb: this.addoneEnb ? 1 : 0,
          l_id: this.optionSelected1.value,
          b_id: this.optionSelected2.value,
          b_name: this.optionSelected2.text,
          s_id: tempOS.value,
          s_name: tempOS.text
        })
        this.$nextTick(() => {
          this.optionSelected3 = tempOS
          this.isShowComponent = true
          this.dialog = false
        })
      }
    },
    handleOnDeleteAddOne() {
      if (!this.optionSelected1) return
      if (!this.optionSelected2) return
      if (!this.optionSelected3) return
      if (!this.optionSelected1.value) return
      if (!this.optionSelected2.value) return
      if (!this.optionSelected3.value) return
      if (this.tableCBSelected.length < 1) return
      const tempOS = this.optionSelected3
      if (!confirm('確定刪除嗎?')) return
      ;(async () => {
        this.isShowComponent = false
        this.optionSelected3 = []
        const ids = []
        this.tableCBSelected.forEach(e => {
          ids.push(e.id)
        })
        const { uid } = this
        await this.deleteAddOneDetail({
          uid,
          ids: ids,
          l_id: this.optionSelected1.value
        })
        this.$nextTick(() => {
          this.optionSelected3 = tempOS
          this.isShowComponent = true
        })
      })()
    },
    handleOnEditAddOne(item) {
      const tempOS = this.optionSelected3
      this.dialogMode = false

      this.addoneModel = item.model
      this.addonePrice = item.price
      this.addoneNewPrice = item.price
      // this.addoneRF = item.rf
      // this.addoneAP = item.ap + '%'
      this.addoneEnb = item.enb

      this.dialog = true

      this.dialogOnSaveFn = async () => {
        if (!this.dialogInputValid) return
        if (
          this.addoneModel === item.model &&
          this.addoneNewPrice === item.price &&
          this.addoneEnb === item.enb
        )
          return

        this.isShowComponent = false
        this.optionSelected3 = []

        const newPrice = this.addoneNewPrice * 1
        const oldPrice = this.addonePrice * 1
        const addoneRF = newPrice * 1 - oldPrice * 1
        const addoneAP = ((newPrice * 1 - oldPrice * 1) / oldPrice) * 100
        const { addoneModel, uid } = this
        await this.updateAddOneDetail({
          uid,
          l_id: item.l_id,
          id: item.id,
          addoneModel,
          oldPrice: oldPrice,
          newPrice: newPrice,
          rf: addoneRF,
          ap: addoneAP,
          enb: this.addoneEnb ? 1 : 0
        })
        this.$nextTick(() => {
          this.optionSelected3 = tempOS
          this.isShowComponent = true
          this.dialog = false
        })
      }
    },
    handleOnChangeRF() {
      this.addoneNewPrice = this.addonePrice * 1 + this.addoneRF * 1
    },
    handleOnDialogSave() {
      if (this.dialogOnSaveFn) this.dialogOnSaveFn()
    }
  },
  async created() {
    this.optionSelected1 = { text: '暫無資料', value: -1 }
    this.optionSelected2 = { text: '暫無資料', value: -1 }
    this.optionSelected3 = { text: '暫無資料', value: -1 }
    this.isShowComponent = false
    const { uid } = this
    await this.getAddOneAllOptionList({ uid })
    this.$nextTick(async () => {
      if (this.addonelistlist1.length > 0)
        this.optionSelected1 = this.addonelistlist1[0]
      if (this.addonelistlist2.length > 0)
        this.optionSelected2 = this.addonelistlist2[0]
      if (this.addonelistlist3.length > 0)
        this.optionSelected3 = this.addonelistlist3[0]
      // this.isShowComponent = true
      let l_id = 1
      if (this.optionSelected1.value) l_id = this.optionSelected1.value
      await this.getAddOneDetails({ uid, l_id: l_id })
      this.optionSelected3 = ''
      this.$nextTick(async () => {
        if (this.addonelistlist3.length > 0)
          this.optionSelected3 = this.addonelistlist3[0]
        this.isShowComponent = true
      })
    })
  },
  mounted() {}
}
</script>

<style lang="scss">
.my-component-list-table {
  th,
  td {
    font-size: 18px;
  }
}

@media screen and (max-width: 600px) {
  .my-component-list-combobox {
    .col {
      padding-bottom: 0px !important;
    }

    .v-input {
      label,
      input {
        font-size: 20px;
      }
    }
  }

  .my-component-list-table {
    th,
    td {
      padding-right: 2px !important;
      padding-left: 2px !important;
    }

    .v-data-footer {
      .v-data-footer__select {
        margin-right: 0px;
      }
    }
  }
}
</style>
